"use client";
import { useState, useEffect } from "react";
import { createPortal } from "react-dom";

interface PersonalizationToastProps {
	isVisible: boolean;
	onClose: () => void;
	onAgree?: () => void;
	message?: string;
	ctaText?: string;
	hideCTA?: boolean;
}

export function PersonalizationToast({ isVisible, onClose, onAgree, message, ctaText, hideCTA }: PersonalizationToastProps) {
	const [shouldRender, setShouldRender] = useState(isVisible);
	const [mounted, setMounted] = useState(false);

	useEffect(() => {
		setMounted(true);
		if (isVisible) {
			setShouldRender(true);
		} else {
			const timer = setTimeout(() => {
				setShouldRender(false);
			}, 300);
			return () => clearTimeout(timer);
		}
	}, [isVisible]);

	const handleAgreeClick = () => {
		if (onAgree) onAgree();
		onClose();
	};

	if (!shouldRender || !mounted) return null;

	return createPortal(
		<div
			className={`fixed left-1/2 transform -translate-x-1/2 z-[9999] transition-all duration-300 w-[90vw] sm:w-[600px] ${
				isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"
			}`}
			style={{ bottom: "60px" }}
		>
			<div className="bg-[rgba(255,255,255,0.7)] relative rounded-[16px] shadow-[0px_0px_18px_0px_rgba(162,166,173,0.2)] min-h-[76px] backdrop-blur-sm">
				<div className="relative">
					<div className="box-border flex items-center justify-between px-6 py-4 relative gap-3">
						<div className="flex gap-3 items-center justify-start relative flex-1 min-w-0">
							<img 
								src={message?.includes('켜졌습니다') || message?.includes('해제되었습니다') ? "/svg/private.svg" : "/svg/error.svg"} 
								alt="icon" 
								width={24} 
								height={24} 
								className="flex-shrink-0"
							/>
							<div
								className="font-['Pretendard:Regular',_sans-serif] not-italic relative text-[#454852] flex-1 min-w-0"
								style={{ 
									fontSize: "16px", 
									fontWeight: 400, 
									lineHeight: "1.4",
									display: '-webkit-box',
									WebkitLineClamp: 2,
									WebkitBoxOrient: 'vertical',
									overflow: 'hidden',
									textOverflow: 'ellipsis'
								}}
							>
								{message || '개인화 서비스를 이용하시려면 동의가 필요합니다.'}
							</div>
						</div>
						{hideCTA ? null : (
							<button
								className="bg-[#010103] flex items-center justify-center px-4 py-2 sm:px-6 sm:py-3 relative rounded-[8px] flex-shrink-0 cursor-pointer hover:opacity-90 transition-opacity"
								onClick={handleAgreeClick}
							>
								<div
									className="font-['Pretendard:Medium',_sans-serif] not-italic relative text-[#ffffff] whitespace-nowrap"
									style={{ fontSize: "14px", fontWeight: 500, letterSpacing: "-0.28px", lineHeight: "normal" }}
								>
									{ctaText || '동의하러 가기'}
								</div>
							</button>
						)}
					</div>
				</div>
			</div>
		</div>,
		document.body
	);
}

